import React from 'react';
import { Box, Typography } from '@mui/material';
import ShieldIcon from '@mui/icons-material/VerifiedUser';
import { isMobile } from '../utils/miscutils';
import Sheild from '../utils/images/Vector.svg';

const MobileSecurityFooter = () => {
  const isMobileView = isMobile(window.innerWidth);

  if (!isMobileView) {
    return null; 
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '12px',
        }}
      >
        <img src={Sheild} alt="Shield" height="37px" width="37px" />
      </Box>
      <Typography
        sx={{
          fontSize: '13px',
          color: '#9dabbd',
          lineHeight: '16px',
          maxWidth: '90%',
          fontWeight: 500,
        }}
      >
        Your personal health data is 100% safe and secure.
        <br />
        It can never be shared without your permission
      </Typography>
    </Box>
  );
};

export default MobileSecurityFooter;